import { SITE_ARTICLES_GRID_NAME } from '../../constants';

import { actionLoadSiteArticlesRequest } from '../../actions/siteArticlesGrid';

import {
  ACTION_CANCEL_SITE_ARTICLE__REQUEST,
  ACTION_CANCEL_SITE_ARTICLE__SUCCESS,
  ACTION_CANCEL_SITE_ARTICLE__FAIL,
} from '../../actionTypes';

import { getGridSaga } from 'react-redux-app/lib/modules/grid/sagas';


export default getGridSaga(
  SITE_ARTICLES_GRID_NAME,
  actionLoadSiteArticlesRequest,
  [ACTION_CANCEL_SITE_ARTICLE__REQUEST],
  [ACTION_CANCEL_SITE_ARTICLE__FAIL],
  [ACTION_CANCEL_SITE_ARTICLE__SUCCESS]
);
